import { AccessProtectedPage } from './AccessProtectedPage';
import { ProductType } from 'types';
import { useCallback } from 'react';
import { TraceStandaloneWrapper } from './components/TraceStandaloneWrapper';

export const TracePage = () => {
  return (
    <AccessProtectedPage
      productType={ProductType.TRACE}
      renderContent={useCallback(
        () => (
          <TraceStandaloneWrapper productType={ProductType.TRACE} />
        ),
        [],
      )}
    />
  );
};
